{
  "actions": {
    "cancel": "Cancelar",
    "create": "Criar",
    "save": "Salvar",
    "link": "Vincular",
    "unlink": "Desvincular"
  },
  "toasts": {
    "lessonCreated": "Aula criada com sucesso",
    "lessonCreateError": "Erro ao criar aula",
    "moduleCreated": "Módulo criado com sucesso",
    "moduleCreateError": "Erro ao criar módulo",
    "lessonDeleted": "Aula removida",
    "lessonDeleteError": "Erro ao remover aula",
    "moduleDeleted": "Módulo removido",
    "moduleDeleteError": "Erro ao remover módulo",
    "courseLinked": "Módulo vinculado ao curso",
    "courseLinkError": "Erro ao vincular módulo ao curso",
    "courseUnlinked": "Módulo desvinculado do curso",
    "courseUnlinkError": "Erro ao desvincular módulo do curso",
    "lessonLinked": "Aula vinculada ao módulo",
    "lessonLinkError": "Erro ao vincular aula",
    "lessonUnlinked": "Aula desvinculada do módulo",
    "lessonUnlinkError": "Erro ao desvincular aula",
    "lessonMoved": "Aula movida com sucesso",
    "lessonMoveError": "Erro ao mover aula",
    "lessonsReorderError": "Erro ao reordenar aulas",
    "lessonUpdated": "Aula atualizada",
    "lessonUpdateError": "Erro ao atualizar aula",
    "moduleUpdated": "Módulo atualizado",
    "moduleUpdateError": "Erro ao atualizar módulo"
  },
  "lessonTypes": {
    "video": "Vídeo",
    "text": "Texto",
    "quiz": "Quiz",
    "assignment": "Atividade",
    "live": "Ao Vivo"
  },
  "list": {
    "title": "Módulos",
    "totalRegistered_one": "{{count}} módulo cadastrado",
    "totalRegistered_zero": "{{count}} módulos cadastrados",
    "totalRegistered_other": "{{count}} módulos cadastrados",
    "subtitle": "Gerencie módulos, sub-módulos e aulas",
    "newModule": "Novo Módulo",
    "searchPlaceholder": "Buscar módulos...",
    "pagination": {
      "showing": "Mostrando <bold>{{from}}</bold> – <bold>{{to}}</bold> de <bold>{{total}}</bold> módulos",
      "previous": "Anterior",
      "next": "Próxima"
    }
  },
  "table": {
    "loading": "Carregando módulos...",
    "empty": {
      "title": "Nenhum módulo encontrado",
      "searchHint": "Tente outra busca",
      "createHint": "Crie seu primeiro módulo para organizar as aulas"
    },
    "columns": {
      "thumb": "Thumb",
      "name": "Nome",
      "lessons": "Aulas",
      "courses": "Cursos",
      "actions": "Ações"
    }
  },
  "row": {
    "edit": "Editar módulo",
    "delete": "Excluir módulo",
    "deleteConfirm": {
      "title": "Excluir módulo",
      "description": "Tem certeza que deseja excluir \"{{title}}\"? Esta ação não pode ser desfeita.",
      "confirm": "Excluir"
    }
  },
  "moduleForm": {
    "newModule": "Novo Módulo",
    "newSubModule": "Novo Sub-módulo",
    "name": "Nome",
    "namePlaceholder": "Nome do módulo",
    "description": "Descrição",
    "descriptionPlaceholder": "Descrição (opcional)",
    "thumbnail": "Thumbnail"
  },
  "edit": {
    "loading": "Carregando módulo...",
    "notFound": "Módulo não encontrado",
    "backToModules": "Voltar para módulos",
    "modules": "Módulos",
    "subModuleOf": "Sub-módulo de {{title}}",
    "tabs": {
      "basic": "Informações",
      "content": "Conteúdo",
      "community": "Comunidade"
    }
  },
  "content": {
    "newLesson": "Nova Aula",
    "linkLesson": "Vincular Aula",
    "linkCourse": "Vincular a Curso",
    "lessonsCount": "Aulas ({{count}})"
  },
  "community": {
    "unavailable": {
      "locked": "vitrine trancada",
      "noPosts": "não aceita posts"
    },
    "notConfigured": {
      "title": "Comunidade não configurada",
      "description": "Defina a variável <code>{{variable}}</code> no backend e reinicie o servidor para liberar o vínculo entre trilhas e espaços da comunidade."
    },
    "spaceLabel": "Espaço da comunidade",
    "loadingSpaces": "Carregando espaços...",
    "chooseSpace": "Escolha um espaço",
    "inherit": "Herdar do curso",
    "help": "Escolher um espaço aqui sobrescreve, apenas para as aulas deste módulo, o espaço definido no curso. Use \"Herdar do curso\" para voltar ao padrão.",
    "empty": "Nenhum espaço encontrado na comunidade. Crie um espaço por lá para poder vinculá-lo aqui."
  },
  "lessonList": {
    "empty": "Nenhuma aula neste módulo",
    "columns": {
      "title": "Título",
      "type": "Tipo",
      "createdAt": "Criado em",
      "actions": "Ações"
    }
  },
  "lessonRow": {
    "edit": "Editar aula",
    "move": "Mover para outro módulo",
    "delete": "Excluir aula",
    "deleteConfirm": {
      "title": "Excluir aula",
      "description": "Tem certeza que deseja excluir \"{{title}}\"?",
      "confirm": "Excluir"
    }
  },
  "linkedCourses": {
    "title": "Cursos vinculados",
    "unlink": "Remover vínculo"
  },
  "subModules": {
    "title": "Sub-módulos",
    "add": "Sub-módulo",
    "empty": "Nenhum sub-módulo",
    "edit": "Editar sub-módulo",
    "delete": "Excluir sub-módulo",
    "lessonCount_one": "{{count}} aula",
    "lessonCount_zero": "{{count}} aulas",
    "lessonCount_other": "{{count}} aulas",
    "deleteConfirm": {
      "title": "Excluir sub-módulo",
      "description": "Tem certeza que deseja excluir \"{{title}}\"? Esta ação não pode ser desfeita.",
      "confirm": "Excluir"
    }
  },
  "lessonForm": {
    "newTitle": "Nova Aula",
    "editTitle": "Editar Aula",
    "title": "Título",
    "titlePlaceholder": "Título da aula",
    "type": "Tipo",
    "description": "Descrição",
    "descriptionPlaceholder": "Descrição (opcional)",
    "content": "Conteúdo",
    "contentPlaceholder": "Conteúdo da aula..."
  },
  "linkCourse": {
    "title": "Vincular a Curso",
    "searchPlaceholder": "Buscar cursos...",
    "notFound": "Nenhum curso encontrado",
    "noPublished": "Nenhum curso publicado"
  },
  "linkLesson": {
    "title": "Vincular Aula Existente",
    "searchPlaceholder": "Buscar aulas...",
    "notFound": "Nenhuma aula encontrada",
    "typeToSearch": "Digite para buscar"
  },
  "moveLesson": {
    "title": "Mover Aula",
    "selectTarget": "Selecione o módulo de destino",
    "noModules": "Nenhum módulo disponível",
    "moving": "Movendo..."
  },
  "convertCourse": {
    "error": "Erro ao converter curso em módulo",
    "title": "Converter Curso em Módulo",
    "description": "Transformar \"{{title}}\" em um módulo",
    "warningTitle": "Atenção",
    "warningDescription": "O curso será convertido em um módulo e arquivado. Todas as aulas serão preservadas dentro do novo módulo.",
    "stats": "$t(adminModules:convertCourse.modulesCount, {\"count\": {{modules}} }) · $t(adminModules:convertCourse.lessonsCount, {\"count\": {{lessons}} }) · $t(adminModules:convertCourse.studentsCount, {\"count\": {{students}} })",
    "modulesCount_one": "{{count}} módulo",
    "modulesCount_zero": "{{count}} módulos",
    "modulesCount_other": "{{count}} módulos",
    "lessonsCount_one": "{{count}} aula",
    "lessonsCount_zero": "{{count}} aulas",
    "lessonsCount_other": "{{count}} aulas",
    "studentsCount_one": "{{count}} aluno",
    "studentsCount_zero": "{{count}} alunos",
    "studentsCount_other": "{{count}} alunos",
    "targetLabel": "Vincular ao curso (opcional)",
    "targetSearchPlaceholder": "Buscar curso de destino...",
    "noTarget": "Nenhum (apenas converter)",
    "notFound": "Nenhum curso encontrado",
    "targetHelp": "Se selecionado, o módulo criado será automaticamente vinculado a este curso",
    "submit": "Converter"
  },
  "videoUpload": {
    "label": "Vídeo da Aula",
    "gumletLinked": "Vídeo Gumlet vinculado",
    "unsupportedFormat": "Formato não suportado. Use MP4, WebM, MOV ou AVI.",
    "tooLarge": "Vídeo muito grande ({{size}}). Máx: 5GB",
    "uploaded": "Vídeo enviado com sucesso",
    "noUrl": "Não foi possível obter a URL do vídeo",
    "uploadError": "Erro ao enviar vídeo",
    "previewTitle": "Prévia do vídeo",
    "gumletId": "Gumlet ID: {{id}}",
    "directUpload": "Upload direto",
    "remove": "Remover Vídeo",
    "gumletPlaceholder": "Cole o ID do vídeo Gumlet",
    "invalidId": "ID inválido. Deve ter 24 caracteres hexadecimais.",
    "previewUrl": "Preview: {{url}}",
    "showDirectUpload": "Ou fazer upload direto de um arquivo",
    "directUploadTitle": "Upload Direto (S3)",
    "uploading": "Enviando vídeo...",
    "dropHint": "Arraste ou clique para selecionar (MP4, WebM, MOV, AVI - máx 5GB)",
    "linkTitle": "Link do vídeo (YouTube, Vimeo ou Panda Video)",
    "linkPlaceholder": "Cole o link do vídeo",
    "linkInvalid": "Link não reconhecido. Use um link do YouTube, Vimeo ou Panda Video.",
    "linkDetected": "Vídeo do {{provider}} detectado",
    "linkLinked": "Vídeo vinculado",
    "linkedFrom": "Tocando pelo player da área · {{provider}}",
    "gumletTitle": "Ou use um vídeo hospedado na Gumlet",
    "streamTitle": "Vídeo com streaming protegido (recomendado)"
  },
  "quizForm": {
    "newTitle": "Novo Quiz",
    "editTitle": "Editar Quiz",
    "description": "Configure as perguntas do quiz",
    "basicInfo": "Informações Básicas",
    "settings": "Configurações",
    "submitCreate": "Criar Quiz",
    "submitUpdate": "Atualizar Quiz",
    "validation": {
      "optionTextRequired": "Texto da opção é obrigatório",
      "questionRequired": "Pergunta é obrigatória",
      "pointsMin": "Pontos devem ser maiores que 0",
      "optionsMin": "Pelo menos uma opção é necessária",
      "titleRequired": "Título é obrigatório",
      "timeLimitMin": "Tempo limite deve ser maior que 0",
      "passingScoreRange": "Nota deve estar entre 0 e 100",
      "maxRetriesMin": "Máximo de tentativas deve ser maior que 0",
      "questionsMin": "Pelo menos uma questão é necessária"
    },
    "fields": {
      "title": "Título *",
      "titlePlaceholder": "Ex: Avaliação do Módulo 1",
      "description": "Descrição",
      "descriptionPlaceholder": "Descreva o objetivo desta avaliação",
      "instructions": "Instruções",
      "instructionsPlaceholder": "Instruções específicas para os alunos",
      "passingScore": "Nota mínima (%)",
      "timeLimit": "Tempo limite (minutos)",
      "timeLimitPlaceholder": "Deixe vazio para sem limite",
      "allowRetries": "Permitir retentativas",
      "allowRetriesHelp": "Alunos podem refazer a avaliação",
      "showResults": "Mostrar resultados",
      "showResultsHelp": "Exibir nota ao finalizar",
      "showCorrectAnswer": "Mostrar respostas corretas",
      "showCorrectAnswerHelp": "Exibir gabarito após finalizar",
      "randomizeOrder": "Ordem aleatória",
      "randomizeOrderHelp": "Embaralhar questões e opções",
      "maxRetries": "Máximo de tentativas",
      "maxRetriesPlaceholder": "Deixe vazio para ilimitado"
    },
    "questions": {
      "title": "Questões",
      "add": "Adicionar Questão",
      "emptyTitle": "Nenhuma questão criada",
      "emptyDescription": "Adicione questões para criar seu quiz",
      "first": "Primeira Questão",
      "question": "Pergunta *",
      "questionPlaceholder": "Digite sua pergunta aqui...",
      "points": "Pontos",
      "explanation": "Explicação (opcional)",
      "explanationPlaceholder": "Explicação que será mostrada após a resposta",
      "options": "Opções de Resposta",
      "addOption": "Adicionar Opção",
      "true": "Verdadeiro",
      "false": "Falso",
      "optionPlaceholder": "Texto da opção"
    },
    "questionTypes": {
      "multipleChoice": "Múltipla Escolha",
      "trueFalse": "Verdadeiro/Falso",
      "essay": "Dissertativa"
    }
  },
  "quizStats": {
    "passed": "Aprovados",
    "failed": "Reprovados",
    "attempts": "Tentativas",
    "title": "Estatísticas: {{title}}",
    "description": "Estatísticas de respostas do quiz",
    "totalAttempts": "Total de Tentativas",
    "totalAttemptsHelp": "Tentativas realizadas",
    "passRate": "Taxa de Aprovação",
    "passRateHelp": "{{passed}} de {{total}} aprovados",
    "averageScore": "Nota Média",
    "averageScoreHelp": "Média geral das tentativas",
    "passedHelp": "Tentativas aprovadas",
    "details": "Detalhes do Quiz",
    "questions": "Questões",
    "questionsCount_one": "{{count}} questão",
    "questionsCount_zero": "{{count}} questões",
    "questionsCount_other": "{{count}} questões",
    "passingScore": "Nota mínima",
    "timeLimit": "Tempo limite",
    "minutes_one": "{{count}} minuto",
    "minutes_zero": "{{count}} minutos",
    "minutes_other": "{{count}} minutos",
    "retries": "Retentativas",
    "maxRetries": "Máximo {{max}}",
    "unlimited": "Ilimitadas",
    "notAllowed": "Não permitidas",
    "questionOrder": "Ordem das questões",
    "random": "Aleatória",
    "fixed": "Fixa",
    "results": "Resultados",
    "showScore": "Exibir nota",
    "hideScore": "Ocultar nota",
    "showAnswerKey": "Mostrar gabarito",
    "distribution": "Distribuição de Resultados",
    "passedCount": "Aprovados ({{value}})",
    "failedCount": "Reprovados ({{value}})",
    "summary": "Resumo Geral",
    "emptyTitle": "Nenhuma tentativa registrada",
    "emptyDescription": "Este quiz ainda não foi respondido por nenhum aluno."
  }
}
